const HUMANIZE_FROM = 10_000;

const grouped = new Intl.NumberFormat("en-US");
const compact = new Intl.NumberFormat("en-US", {
  notation: "compact",
  maximumFractionDigits: 1,
});

export const formatCount = (value: number): string =>
  Math.abs(value) >= HUMANIZE_FROM
    ? compact.format(value)
    : grouped.format(value);

export const formatCountOrDash = (value: number | null | undefined): string =>
  value == null ? "–" : formatCount(value);
